<div class="status">
  <h2>Oops, we couldn't find the page you're looking for</h2>

  <a routerLink="/" mat-flat-button color="primary">
    <rma-icon matButtonIcon glyph="arrow_back" />
    <span>Back to my dashboard</span>
  </a>
</div>
